<template>
    <div >
        <MercenaryHeader :title="'결제수단 관리'" :back-title="'활동 및 설정'" :close-action="() => { $GlobalStore.closeLastModal() }"></MercenaryHeader>

        <div style="flex:1; background-color: #f5f5f5; padding:12px;">
            <p class="tit" style="margin-top:10px; color:#210F03; font-size:16px; font-weight:500; ">결제수단</p>
            <div class="card-list" v-for="(item, i) in pay_methods" :key="i">
                <div class="info" style="display:flex; padding:12px;">
                    <div class="logo" style="padding:10px 18px; background-color: #f5f5f5; border-radius:6px;"><img src="@/assets/images/mypage/ico-card-default.png" alt="" style="width:26px; height:21px;"></div>
                    <div class="card-info" style="flex:1; padding-left: 12px;">
                        <div class="comp" style="color:#210F03; font-size:14px;margin-top:2px;">{{CARD_CODE_NAME[item.card_code] ? CARD_CODE_NAME[item.card_code] : ''}} ({{ item.card_number }}) <span v-if="item.main == '1'">기본</span></div>
                        <div class="exp" style="color:#808080; font-size:14px; margin-top:8px;">{{(item.mmyy ? (item.mmyy.substr(0, 2) + '/' + '20' + item.mmyy.substr(3, 2)) : "&nbsp;")}}</div>
                    </div>
                    <div style="display:grid; place-items: center;" @click="setCurSettingIdx(item.idx); showMenu();">
                        <img :src="require('@/assets/option_black_horizontal.png')" style="width:21px; height:5px;" >
                    </div>
                    <!--<span class="set" @click="setCurSettingIdx(item.idx); editPageOpen('set');">설정</span>-->
                </div>
            </div>
            <div class="btns" style="display:flex; align-items: center; height:48px; background-color: white; border-radius:12px; margin-top:20px; padding:0px 12px;">
                <a class="btn add" style="color:#210F03; font-size:14px; flex:1; font-weight:500;" @click="creditCardAdd(); $Util.sendEventClick('결제수단관리_결제수단_추가')">결제수단 추가</a>
                <img :src="require('@/assets/images/mypage/ico-move.png')" style="width:10px;">
            </div>
        </div>


        <!--설정-->
        <CommonPopupFrame></CommonPopupFrame>

        <BottomPopupMenu :is-open="isShowMenu" :menu-options="menuOptions"/>
    </div>
</template>

<script>
import CommonPopupFrame from './CommonPopupFrame';
import ResponseCode from "../../../ResponseCode";
import {CARD_CODE_NAME} from "../../../Constants";
import BottomPopupMenu from "../../common/BottomPopupMenu";
import MercenaryHeader from "../../common/MercenaryHeader";

export default {
    name: "Payment",
    components: {MercenaryHeader, BottomPopupMenu, CommonPopupFrame },
    data() {
        return {
            CARD_CODE_NAME : CARD_CODE_NAME,
            isDim: false,
            isEmail: false,
            cardList: [
            ],
            isSet: false,
            isAdd: false,
            active: '',
            pay_methods: [],
            main_method: {},
            idx: -1,
            main: null,
            isShowMenu : false,
            menuOptions : {}
        }
    },
    methods: {
        showMenu(){
            this.isShowMenu = true;
        },
        async setMain() {
            const parameters = {};
            parameters.idx = this.idx;

            const res = await this.$Axios.post('/api/paymethod/main', parameters);
            if (res.data.code === ResponseCode.SUCCESS) {
                this.getPayMethods();
            } else {
                this.$GlobalStore.showAlert(res.data.msg);
            }
        },
        deletePayMethod() {
            this.$GlobalStore.showConfirm('<strong style="color: #101014; margin-bottom: 6px; display: inline-block;">결제수단 삭제</strong><br>선택하신 결제수단을 삭제할까요?', async () => {
                if (this.idx == -1) return;
                const parameters = {};
                parameters.idx = this.idx;
                const res = await this.$Axios.post('/api/paymethod/delete', parameters);
                if (res.data.code === ResponseCode.SUCCESS) {
                    this.getPayMethods();
                } else {
                    this.$GlobalStore.showAlert(res.data.msg);
                }
            }, '삭제하기', '취소하기', this.$GlobalStore.CONFIRM_TYPE.VERSION2)
        },
        setCurSettingIdx(idx) {
            this.idx = idx;
        },
        editPageOpen(v) {
            if (v === 'set') this.isSet = true;
            if (v === 'add') this.isAdd = true;
            this.isDim = true;
        },
        close(v) {
            if (v === 'set') this.isSet = false;
            if (v === 'add') this.isAdd = false;
            this.isDim = false;
        },
        regis() {
            this.active = '';
            this.close('set');
        },
        del() {
            this.active = '';
            this.close('set');
        },
        back() {
            this.$GlobalStore.closeLastModal()
        },
        creditCardAdd() {
            this.$GlobalStore.addModal('CardAdd', { completeAction: this.getPayMethods });
        },
        async getPayMethods() {
            const res = await this.$Axios.get('/api/paymethod/list');
            const pay_methods = res.data.pay_methods;

            for (const each of pay_methods) {
                const card_number_arr = each.card_number.split('-');
                each.card_number = card_number_arr[0] + '-' + card_number_arr[1] + '-****-****';
            }

            this.pay_methods = pay_methods;

            const main = pay_methods.findLast((item) => item.main == 1);
            this.main = main;
            console.log(main);
        }
    },
    created() {
        if (this.$Util.isShowDefaultSettings(false)) {
            return
        }
        this.deletePayMethod = this.$Once(this.deletePayMethod);
        this.getPayMethods()

        this.menuOptions = {
            labelAndAction: [
                {label : '기본 결제수단으로 등록', action : () => {this.setMain(); this.isShowMenu = false;this.$Util.sendEventClick('결제수단관리_기본결제수단으로등록')}},
                {label : '삭제', action : () => {this.deletePayMethod(); this.isShowMenu = false;this.$Util.sendEventClick('결제수단관리_삭제')}}
            ],
            isExistCancelBtn : true,
            closeAction : () => {
                this.isShowMenu = false;
            }
        }
    }

}
</script>

<style scoped>
    .card-list{background-color:white; border-radius:12px;}
    .card-list + .card-list{ margin-top: 8px;}
</style>